const questions = [
  {
    quest: `What's your background?`,
    answer: 'I am Highschool graduate',
  },
  {
    quest: `What's your Hobby?`,
    answer: 'Playing Chess',
  },
  {
    quest: `How old are you?`,
    answer: '21 yo, will be 22 this year (Nov, 2021)',
  },
  {
    quest: `What Tools you use to made this portofolio site?`,
    answer: 'React + Gsap (Dev), VsCode (Text Editor), Figma (Design)',
  },
];

export default questions;
